export const handleTextTooltip = () => {
    const textTooltips = document.querySelectorAll('.text-tooltip');
    if (textTooltips.length === 0) return;

    const hideTooltip = tootlip => {
        if (!tootlip) return;
        tootlip.classList.add('-hide');
        setTimeout(() => {
            tootlip.remove();
        }, 250);
    };

    const createTooltip = (tooltip, domToolTipsWrapper) => {
        const domTooltip = document.createElement('div');
        const text = tooltip.querySelector('.text-tooltip__text');
        domTooltip.innerHTML = text.innerHTML;
        domTooltip.classList.add('tooltips-wrapper__tooltip');
        domToolTipsWrapper.appendChild(domTooltip);

        domTooltip.addEventListener('click', () => {
            hideTooltip(domTooltip);
        });

        setTimeout(() => {
            hideTooltip(domTooltip);
        }, 5250);
    };

    const handleTooltipClick = (tooltip, tooltipsWrapper) => {
        if (window.innerWidth > 1023.98) return;
        let domToolTipsWrapper = document.querySelector('.tooltips-wrapper');
        if (!domToolTipsWrapper) {
            document.body.appendChild(tooltipsWrapper);
            domToolTipsWrapper = tooltipsWrapper;
        }

        const domTooltips = domToolTipsWrapper.querySelectorAll(
            '.tooltips-wrapper__tooltip'
        );
        if (domTooltips.length === 0) {
            createTooltip(tooltip, domToolTipsWrapper);
        } else {
            hideTooltip(domTooltips[0]);
            setTimeout(() => {
                createTooltip(tooltip, domToolTipsWrapper);
            }, 250);
        }
    };

    const tooltipsWrapper = document.createElement('div');
    tooltipsWrapper.classList.add('tooltips-wrapper');

    document.querySelector('footer').appendChild(tooltipsWrapper);

    document.addEventListener('click', e => {
        const { target } = e;
        const tooltip = target.classList.contains('.text-tooltip')
            ? target
            : target.parentElement;
        if (tooltip.classList.contains('text-tooltip')) {
            handleTooltipClick(tooltip, tooltipsWrapper);
        }
    });
};
